import {LoaningState} from '../../../common/services/loaning/loaning-states.enum';

/**
 * Le prochain état de la demande par rapport à l'état courant
 */
export interface NextStatusLoaning {
  status: LoaningState; // statut courant de la demande
  nextStatus: LoaningState;
  btnText: string;
  tooltip: string;
}

export const nextStatus: NextStatusLoaning[] = [{
  status: LoaningState.WAITING,
  nextStatus: LoaningState.IN_PROGRESS,
  btnText: 'Passer au traitement',
  tooltip: 'Passer au traitement'
}, {
  status: LoaningState.IN_PROGRESS,
  nextStatus: LoaningState.DONE,
  btnText: 'Finaliser le traitement',
  tooltip: 'Le demandeur sera notifié des scans disponibles sur sa demande'
}, {
  status: LoaningState.DONE,
  nextStatus: LoaningState.IN_PROGRESS,
  btnText: 'Repasser au traitement',
  tooltip: 'La demande sera repassée en traitement'
}];
